import React from 'react';
import { Button } from 'react-admin';
import PersonIcon from '@material-ui/icons/Person';

const HealthCheckButton = ({ record, showAction }) => {
  const l = showAction ? 'Customer' : '';
  if (record.hc_is_complete) {
    return (
      <Button
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        href={record.health_check_url}
        label={l}
      >
        <PersonIcon type="link" fontSize="small" />
      </Button>
    );
  }
  return <div />;
};

HealthCheckButton.defaultProps = {
  addLabel: true,
  showAction: false,
};

export default HealthCheckButton;
